module.exports = __webpack_public_path__ + "img/pptLogo.4919c4dc.png";